import { render, staticRenderFns } from "./DeleteIconCell.vue?vue&type=template&id=61c91438&"
import script from "./DeleteIconCell.vue?vue&type=script&lang=js&"
export * from "./DeleteIconCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c91438')) {
      api.createRecord('61c91438', component.options)
    } else {
      api.reload('61c91438', component.options)
    }
    module.hot.accept("./DeleteIconCell.vue?vue&type=template&id=61c91438&", function () {
      api.rerender('61c91438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/assessments/DeleteIconCell.vue"
export default component.exports